import { Component } from '@angular/core';
import { SidebarService } from '../../services/sidebar.service';

/** Hoogte van de statusregel — gelijk houden aan status-bar.component.scss. */
export const STATUS_BAR_HEIGHT_PX = 24;

@Component({
  selector: 'app-user-layout',
  template: `
    <app-sidebar></app-sidebar>
    <div class="pc-container" [class.zijbalk-ingeklapt]="ingeklapt">
        <router-outlet></router-outlet>
    </div>
    <app-status-bar></app-status-bar>
    <app-mobile-nav></app-mobile-nav>
  `,
  styles: [
  ]
})
export class UserLayoutComponent {

  constructor(private sidebarService: SidebarService) {}

  /**
   * De zijbalk staat vast (`position: fixed`); de pagina houdt er alleen met
   * een linkermarge rekening mee. Klapt de balk in, dan moet die marge mee,
   * anders blijft er een strook leeg staan waar de balk stond.
   */
  public get ingeklapt(): boolean {
    return this.sidebarService.ingeklapt;
  }
}
